export { default as MegaMenu } from './MegaMenu';
